<template>
  <div class="menu-item">
    <hr
      v-if="menuItem.isSeparator"
      class="menu-item__separator"
    >
    <a
      v-else-if="menuItem.routeName == 'notifications'"
      href
      @click.prevent="openModal"
      class="mano"
    >
      <latest-warning-modal
        :show-modal="showModal"
        @close-modal="closeModal"
      />
      <b-badge v-if="notification" pill variant="primary">
        {{ notification }}
      </b-badge>
      <span
        :class="routerLinkClasses(menuItem)"
        class="rounded-circle material-icons"
      >
        {{ menuItem.icon }}
      </span>
      <p
        v-if="isMobile"
        class="menu-item__description"
      >
        {{ menuItem.title }}
      </p>
    </a>
    <a
      v-else-if='menuItem.isMenuGrouper'
      href
      @click.prevent="$emit('open-sub-menu', menuItem.routeName)"
    >
      <b-badge v-if="notification && menuItem.routeName == 'notifications'" pill variant="primary">
        {{ notification }}
      </b-badge>
      <span
        :class="routerLinkClasses(menuItem)"
        class="rounded-circle material-icons"
      >
        {{ menuItem.icon }}
      </span>
      <p
        v-if="isMobile"
        class="menu-item__description"
      >
        {{ menuItem.title }}
      </p>
    </a>
    <a
      v-else-if='isLogout'
      href
      @click.prevent="logout()"
    >
      <span class="rounded-circle material-icons">logout</span>
      <p
        v-if="isMobile"
        class="menu-item__description"
      >
        {{ menuItem.title }}
      </p>
    </a>
    <div
      v-else
      @click.exact="$emit('close-sub-menu', menuItem.routeName)"
    >
      <router-link
        :to="{ name: menuItem.routeName, params: menuItem.params }"
        :exact="menuItem.exact"
      >
        <span
          :class="routerLinkClasses(menuItem)"
          class="rounded-circle material-icons"
        >{{ menuItem.icon }}</span>
        <p
          class="menu-item__description"
          v-if="isMobile">
          {{ menuItem.title }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
import menuTypes from '@/domain/enums/menuTypes';
import MenuItem from '@/domain/data/menu/MenuItem';
import LatestWarningModal from '@/domain/components/generalPanel/latestWarning/LatestWarningModal';
import AuthenticationService from '@/services/authentication';
import store from '@/store';
import { mapGetters } from 'vuex';

export default {
  name: 'MenuItem',
  props: {
    menuItem: {
      type: MenuItem,
      default: () => (new MenuItem()),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLogout: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LatestWarningModal,
  },
  data: () => ({
    menuTypes,
    showModal: false,
  }),
  computed: {
    ...mapGetters([
      'subMenu',
      'notification',
    ]),
  },
  methods: {
    isRouteActive(menuItem) {
      if (!menuItem?.routeName) {
        return false;
      }
      const routeName = this.subMenu.routeName || this.$route.name;
      const [parentRouteName] = routeName.split('.');
      return menuItem.routeName.includes(parentRouteName);
    },
    routerLinkClasses(menuItem) {
      return {
        'menu-item--active': this.isRouteActive(menuItem),
      };
    },
    logout() {
      this.$confirmMessage({ code: 'MC005' })
        .accepted(() => {
          AuthenticationService.logout();
          store.dispatch('setSubMenuItems', { items: [] });
        });
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/variables"

.menu-item
  padding: 4px 8px
  font-size: 1.5em
  text-align: center
  color: $color-menu-item-hover
  +media-xs()
    padding: 0

  &--active
    color: $color-menu-background
    background: $color-menu-item-selected

  & + a
    cursor: pointer

  & a
    max-width: 48px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    position: relative

    +media-max-md()
      max-width: 100%

    & .badge
      font-size: 0.7rem
      color: $color-menu-item-hover !important
      font-weight: normal
      position: absolute
      top: 3px
      right: 1px
      padding: 0.3em 0.5em


    & .rounded-circle
      padding: 12px
      transition: .3s
      max-width: 48px
      max-height: 48px

      &:hover
        color: $color-menu-item-selected
        background: $color-menu-item-hover

  &__description
    font-size: 0.85rem

  &__separator
    width: 40px
    border-top: 1px solid rgba(255, 255, 255, 0.16)

@media not all and (min-resolution: .001dpcm)
  @supports (-webkit-appearance: none)
    .menu-item
      padding: 2px 8px
      font-size: .8em

      & a
        padding-left: 4px
        padding-right: 4px

        & .rounded-circle
          padding: 8px

</style>
